import styled, { css } from 'styled-components';
import { propStyling, tombac } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "PageHeader__Container"
})(["padding:", ";", " ", ""], tombac.space(5, 3, 0, 3), ({
  transparent
}) => transparent ? undefined : css(["background-color:", ";border-bottom:", ";"], tombac.color.white, tombac.parse('1u solid --neutral-400')), propStyling);
const Content = styled.div.withConfig({
  displayName: "PageHeader__Content"
})(["margin:0 auto;max-width:", ";"], tombac.unit(1440));
const PageHeader = ({
  children,
  transparent = false,
  ...stylingProps
}) => /*#__PURE__*/_jsx(Container, {
  className: "PageHeader",
  transparent: transparent,
  ...stylingProps,
  "data-sentry-element": "Container",
  "data-sentry-component": "PageHeader",
  "data-sentry-source-file": "PageHeader.tsx",
  children: /*#__PURE__*/_jsx(Content, {
    "data-sentry-element": "Content",
    "data-sentry-source-file": "PageHeader.tsx",
    "data-sentry-element": "Content",
    children: children
  })
});
export default PageHeader;